import React, { useState } from "react";
import LeftLogo from "./../Assets/images/loginLogo.png";
import { data } from "../variables/variables";
import axios from "axios";
import { login_user } from "./apis";
import { showHeaderAction } from "../Store/headers";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { requestNotificationPermission } from "../Utils/browserNotifications";

//STYLES FILES
import "./../Assets/css/main.css";
import "./../Assets/css/utility.css";

const Login = () => {
  const [userInput, setUserInput] = useState({
    UserName: "",
    UserPassword: "",
  });
  const [userError, setUserError] = useState({
    userName_error: "",
    userPassword_error: "",
  });
  const [login_error, setLogin_error] = useState(false);
  const [redirectApp, setRedirectApp] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({
    query: "(min-width: 769px)",
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setUserInput({
      ...userInput,
      [name]: value,
    });
    setLogin_error(false);
    setUserError({
      userName_error: "",
      userPassword_error: "",
    });
  };

  const handleSubmit = async () => {
    if (userInput.UserName === "") {
      setUserError({
        ...userError,
        userName_error: data["userName_error"],
        userPassword_error: "",
      });
      return false;
    } else if (userInput.UserPassword === "") {
      setUserError({
        ...userError,
        userPassword_error: data["userPassword_error"],
        userName_error: "",
      });
      return false;
    } else {
      setUserError({
        ...userError,
        userName_error: "",
        userPassword_error: "",
      });
    }
    setLoading(true);

    let payload = {
      email: userInput.UserName,
      password: userInput.UserPassword,
    };

    try {
      const res = await axios.post(login_user, payload);
      if (res?.data?.success === true) {
        dispatch(
          showHeaderAction.setHeader({
            Authorization: "Bearer " + res.data.data.token,
          })
        );
        localStorage.setItem("user", JSON.stringify(res?.data.data));
        // Ask for OS notification permission right after login (user gesture).
        await requestNotificationPermission();
        setRedirectApp(true);
      } else if (res?.data?.success === false) {
        setLogin_error(true);
      }
    } catch (error) {
      setLogin_error(true);
    }
    setLoading(false);
  };

  const user = JSON.parse(localStorage.getItem("user"));

  if (user?.token || redirectApp) {
    return <Navigate replace to="/" />;
  }

  return (
    <div className="container-fluid">
      <div className="row">
        {isMobile && (
          <div className="col-md-8 col-sm-12 col-lg-7 leftConent">
            <img className="img" src={LeftLogo} alt="left logo" />
          </div>
        )}

        <div className="col-md-4 col-sm-12 col-lg-5 rightContent">
          <div className="formContent">
            <h3>{data["login"]}</h3>
            {login_error && (
              <h6 className="error_text">{data["login_error"]}</h6>
            )}
            <div className="formInputs">
              <div className="form-group" style={{ width: "100%" }}>
                <input
                  placeholder="USERNAME"
                  name="UserName"
                  id="UserName"
                  value={userInput.UserName}
                  onChange={handleInput}
                  type="text"
                />
                {userError.userName_error && (
                  <small className="form-text text-muted pl-2 error_text">
                    {userError.userName_error}
                  </small>
                )}
              </div>
              <div className="form-group" style={{ width: "100%" }}>
                <input
                  placeholder="PASSWORD"
                  name="UserPassword"
                  id="UserPassword"
                  value={userInput.UserPassword}
                  onChange={handleInput}
                  type="password"
                />
                {userError.userPassword_error && (
                  <small className="form-text text-muted pl-2 error_text">
                    {userError.userPassword_error}
                  </small>
                )}
              </div>
            </div>
            <div className="btnBlog">
              <button className="btn-brown" onClick={handleSubmit}>
                {loading ? (
                  <div
                    className="spinner-border text-light"
                    role="status"
                  ></div>
                ) : (
                  ""
                )}
                {data["login"]}
              </button>
              <p className="pl-3">{data["forgot_password"]}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
